
import zhMessages from '../locales/zh-Hans';

const ZhLan = {
   messages: {
      ...zhMessages
   },
   locale: 'zh-Hans-CN',

};
export default ZhLan;